export default function ProfileCard({ p, className = "" }) {
  return (
    <div
      data-testid={`profile-card-${p.name.toLowerCase()}`}
      className={`w-[212px] sm:w-[232px] shrink-0 bg-ivory-light rounded-[6px] border border-burgundy/10 overflow-hidden shadow-[0_18px_44px_rgba(38,32,32,0.12)] ${className}`}
    >
      <div className="aspect-[3/4] overflow-hidden">
        <img
          src={p.img}
          alt={`${p.name}, ${p.age} — ${p.city} (temsili profil)`}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out hover:scale-105"
        />
      </div>
      <div className="p-4">
        <p className="font-serif text-xl text-ink leading-none">
          {p.name}, {p.age}
        </p>
        <p className="text-xs text-ink-muted mt-1.5">{p.city}</p>
      </div>
    </div>
  );
}
